import request from '@/utils/request'

export function login(type,account, password,img_code) {
  return request({
    url: '/api/userend/login',
    method: 'post',
    data: {
      type,
      account,
      password,
      img_code
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/api/userend/user/info',
    method: 'get',
    params: { }
  })
}

// export function logout() {
//   return request({
//     url: '/api/backend/user/logout',
//     method: 'post'
//   })
// }
